import { MenuItem, TabPane } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledTabWrapper = styled.div`
  padding: 20px;
  .field {
    margin-bottom: 1.4rem !important;
  }
`
export const StyledTabPane = styled(TabPane)`
  padding: 0 !important;
  background: none !important;
  border: none !important;
  padding-bottom: 1rem !important;
`
export const StyledHeaderWrapper = styled.div`
display: flex;
justify-content: space-between;
margin-bottom: 50px;
align-items: center;
 .content {
  display: flex;
  align-items: baseline;
  fontSize: 1.1em;
 }
`
export const StyledFileWrapper = styled.div`
margin: 1em;
margin-left: 0;
display: flex;
justify-content: space-between;
`
export const StyledMenuItem = styled(MenuItem)`
 .error {
  color: red;
 }
`